import { cn } from "@/lib/utils";

export const Tabs = ({ 
  tabs = [],
  activeTab,
  onChange,
  className 
}) => {
  return (
    <div 
      className={cn(
        "flex items-center gap-1 p-1 bg-graphite rounded-lg border border-white/[0.06]",
        className
      )}
      data-testid="tabs"
      role="tablist"
    >
      {tabs.map((tab) => (
        <button
          key={tab.value}
          onClick={() => onChange?.(tab.value)}
          className={cn(
            "px-4 py-2 rounded-md text-sm font-medium transition-all duration-200",
            activeTab === tab.value
              ? "bg-white/[0.08] text-cloud-white"
              : "text-soft-silver hover:text-cloud-white hover:bg-white/[0.03]"
          )}
          role="tab"
          aria-selected={activeTab === tab.value}
          data-testid={`tab-${tab.value}`}
        >
          {tab.icon && <tab.icon className="w-4 h-4 mr-2 inline-block" />}
          {tab.label}
          {tab.count !== undefined && (
            <span className={cn(
              "ml-2 px-2 py-0.5 rounded-full text-xs font-mono",
              activeTab === tab.value
                ? "bg-electric-ice-blue/20 text-electric-ice-blue"
                : "bg-white/[0.05] text-muted-text"
            )}>
              {tab.count}
            </span>
          )}
        </button>
      ))}
    </div>
  );
};

export default Tabs;
